import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAppBar,{attrs:{"bottom":"","fixed":"","height":"84px"}},[_c(VToolbarTitle,{staticClass:"d-none d-md-flex"},[_c('router-link',{attrs:{"to":{ name: 'home'}}},[_vm._v("\n      The Literal Chinese Dictionary\n      "),_c('span',{staticClass:"grey--text d-none d-lg-inline-flex"},[_vm._v(" | 直譯詞典")])])],1),_c(VSpacer,{staticClass:"d-none d-md-flex"}),_c(VIcon,[_vm._v(_vm._s(_vm.mdiMagnify))]),_c('SearchBox')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }